import { useContext } from 'react';
import { AuthContext } from '@/context/auth.context';
import useGetApi from 'src/api/useGetApi';

// Schema that defines how to order product attributes for selection UIs
// Keys are stable identifiers (prefer `customFieldId` over names)
export type ProductAttributeOrderConfig = {
  // Highest priority: specific products
  byProductId?: Record<string, string[]>; // productId -> ordered list of customFieldId
  // Fallback ordering to use when no product-specific or template-specific order exists
  global?: string[]; // ordered list of customFieldId
};

export interface OrganizationConfig {
  id: string;
  organizationId: string;
  organization: {
    name: string;
  };
  enabledModules: string[];
  logoUrl: string | null;
  timezone: string;
  defaultCurrency: string;
  // Optional attribute ordering schema surfaced from backend
  productAttributeOrder: ProductAttributeOrderConfig | null;
  // Ids into `comm_contacts` (internal contacts) auto-CC'd on composed replies.
  defaultCcRecipientIds: string[];
}

type ApiResponse = {
  organizationConfig: OrganizationConfig | null;
};

const useOrganizationConfig = () => {
  const { currentUser } = useContext(AuthContext);

  return useGetApi<ApiResponse>({
    endpoint: 'organization/config',
    options: {
      enabled: !!currentUser,
      gcTime: Infinity,
    },
  });
};

export default useOrganizationConfig;
